export const POST_VEHICLE_CONTROL_REQUEST = 'POST_VEHICLE_CONTROL_REQUEST';
export const GET_VEHICLE_CONTROL_REQUEST = 'GET_VEHICLE_CONTROL_REQUEST';
export const GET_VEHICLE_CONTROL_HISTORY = 'GET_VEHICLE_CONTROL_HISTORY';
